import fetchService from 'common/actions/fetchService';
import providerId from 'modules/bus/shared/selectors/userConfig/busProviderId';

export default ({ pnrCode, tripItineraryId }) => async (dispatch, getState) => {
  return dispatch(
    fetchService(({ pssService }) =>
      pssService.fetch('POST', '/api/v2/busextranetagent/booking/cancel', {
        pnrCode,
        tripItineraryId,
        providerId: providerId(getState()),
      })
    )
  );
};
